import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useStyle } from "../../../../../runtimes/react/use-style";
var Placeholder_default = forwardRef(function Placeholder({ hide = false, ...restOfProps }, ref) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...restOfProps,
      ref,
      style: { visibility: hide ? "hidden" : "initial" },
      className: useStyle({
        width: "100%",
        background: "rgba(161, 168, 194, 0.18)",
        height: 80,
        padding: 8
      }),
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "100%",
          height: "100%",
          style: { overflow: "visible" },
          children: /* @__PURE__ */ jsx(
            "rect",
            {
              x: 0,
              y: 0,
              width: "100%",
              height: "100%",
              strokeWidth: 2,
              strokeDasharray: "4 2",
              fill: "none",
              stroke: "rgba(161, 168, 194, 0.40)",
              rx: "4",
              ry: "4"
            }
          )
        }
      )
    }
  );
});
export {
  Placeholder_default as default
};
//# sourceMappingURL=index.js.map